import { createAction } from "redux-actions";
import {
    createAsyncActions,
    runAsyncWorkflow
  } from '../lib/reduxHelpers';

  import { ReadingProgram } from '../api';


  export const [
    fetchAllFluences,
    receiveAllFluences,
    fetchAllFluencesError
  ] = createAsyncActions(
    'ALL_FLUENCES',
    () => ({}),
    ({ data }) => ({ fluences: data.fluences })
  );

  export const fetchAllFluence = () => {
    const fetchPromise = ReadingProgram.fetchFluences();

    return runAsyncWorkflow({
      fetch: fetchAllFluences,
      receive: receiveAllFluences,
      error: fetchAllFluencesError
    }, fetchPromise);
  };

  export const [
    fetchAllThemes,
    receiveAllThemes,
    fetchAllThemesError
  ] = createAsyncActions(
    'FETCH_THEMES',
    ({ id }) => ({ id }),
    ({ data }) => ({ fluency: data })
  );

  export const fetchThemes = (id) => {
    const fetchPromise = ReadingProgram.fluencyThemes(id);

    return runAsyncWorkflow({
      fetch: fetchAllThemes,
      receive: receiveAllThemes,
      error: fetchAllThemesError
    }, fetchPromise);
  };

  export const [
    fetchThemeDetails,
    receiveThemeDetails,
    fetchThemeDetailsError
  ] = createAsyncActions(
    'FETCH_THEME_DETAILS',
    ({ id }) => ({ id }),
    ({ data }) => ({ themeDetails: data })
  );

  export const fetchThemeDetail = (fluencyLevel, themeNumber) => {
    const fetchPromise = ReadingProgram.themeDetails(fluencyLevel, themeNumber);

    return runAsyncWorkflow({
      fetch: fetchThemeDetails,
      receive: receiveThemeDetails,
      error: fetchThemeDetailsError
    }, fetchPromise);
  };

  export const [
    enrollUserToFluency,
    receiveenrollUserToFluency,
    enrollUserToFluencyError
  ] = createAsyncActions(
    'ENROLL_USER_TO_FLUENCY',
    ({ userId, fluencyId, userType, studentNumber, isFromCbse }) => ({ userId, fluencyId, userType, studentNumber, isFromCbse }),
    ({ ok }) => ({ enrolled: ok })
  );

  export const enrollUser = (userId, fluence_level, userType, studentNumber, isFromCbse, isFromGoa, details) => {
    const fetchPromise = ReadingProgram.enrollUser(userId, fluence_level, userType, studentNumber, isFromCbse, isFromGoa, details);

    return runAsyncWorkflow({
      fetch: enrollUserToFluency,
      receive: receiveenrollUserToFluency,
      error: enrollUserToFluencyError
    }, fetchPromise);
  };

  export const [
    fetchUserEnrolled,
    receiveUserEnrolled,
    fetchUserEnrolledError
  ] = createAsyncActions(
    'CHECK_USER_ENROLLED',
    ({ userId, fluencyId }) => ({ userId, fluencyId }),
    ({ ok, data }) => ({ isEnrolled: ok, data: data })
  );

  export const checkEnrollStatus = (userId, fluencyId) => {
    const fetchPromise = ReadingProgram.checkUserEnrolled(userId, fluencyId);

    return runAsyncWorkflow({
      fetch: fetchUserEnrolled,
      receive: receiveUserEnrolled,
      error: fetchUserEnrolledError
    }, fetchPromise);
  };

  export const [
    fetchStoryStatus,
    receiveStoryStatus,
    fetchStoryStatusError
  ] = createAsyncActions(
    'CHECK_STORY_STATUS',
    ({ themeId, enrollmentId }) => ({ themeId, enrollmentId }),
    ({ data }) => ({ status: data.themeStoriesStatus, label: data.reading_progress_text})
  );

  export const checkStoryStatus = (fluencyLevel ,themeNumber, enrollmentId) => {
    const fetchPromise = ReadingProgram.checkStoryStatus(fluencyLevel ,themeNumber, enrollmentId);

    return runAsyncWorkflow({
      fetch: fetchStoryStatus,
      receive: receiveStoryStatus,
      error: fetchStoryStatusError
    }, fetchPromise);
  };

  export const [
    fetchFluenceProgress,
    receiveFluenceProgress,
    fetchFluenceProgressError
  ] = createAsyncActions(
    'GET_FLUENCY_PROGRESS',
    ({ fluencyId }) => ({ fluencyId }),
    ({ data }) => ({ progress: data })
  );

  export const getFluenceProgress = (fluencyId) => {
    const fetchPromise = ReadingProgram.getFluenceProgress(fluencyId);

    return runAsyncWorkflow({
      fetch: fetchFluenceProgress,
      receive: receiveFluenceProgress,
      error: fetchFluenceProgressError
    }, fetchPromise);
  };

  export const [
    fetchNextSuggestion,
    receiveNextSuggestion,
    fetchNextSuggestionError
  ] = createAsyncActions(
    'GET_NEXT_SUGGESTION',
    ({ enrollmentId }) => ({ enrollmentId }),
    ({ data }) => ({ suggestion: data })
  );

  export const getNextSuggestion = (enrollmentId) => {
    const fetchPromise = ReadingProgram.getNextSuggestion(enrollmentId);

    return runAsyncWorkflow({
      fetch: fetchNextSuggestion,
      receive: receiveNextSuggestion,
      error: fetchNextSuggestionError
    }, fetchPromise);
  };

  export const [
    fetchNextStorySuggestion,
    receiveNextStorySuggestion,
    fetchNextStorySuggestionError
  ] = createAsyncActions(
    'GET_NEXT_STORY_SUGGESTION',
    ({ themeId, enrollmentId }) => ({ themeId, enrollmentId }),
    ({ data }) => ({ suggestion: data.nextThemeSuggestion })
  );

  export const getNextStorySuggestion = (themeId, enrollmentId) => {
    const fetchPromise = ReadingProgram.getNextStorySuggestion(themeId, enrollmentId);

    return runAsyncWorkflow({
      fetch: fetchNextStorySuggestion,
      receive: receiveNextStorySuggestion,
      error: fetchNextStorySuggestionError
    }, fetchPromise);
  };

  export const [
    setStoryStatus,
    receiveSetStoryStatus,
    setStoryStatusError
  ] = createAsyncActions(
    'SET_STORY_STATUS',
    ({ storyId, enrollmentId, themeId, status }) => ({ storyId, enrollmentId, themeId, status }),
    ({ data }) => ({ readStoryStatus: data })
  );

  export const setStoryStatusFn = (storyId, enrollmentId, theme_number, status) => {
    const fetchPromise = ReadingProgram.setStoryStatus(storyId, enrollmentId, theme_number, status);

    return runAsyncWorkflow({
      fetch: setStoryStatus,
      receive: receiveSetStoryStatus,
      error: setStoryStatusError
    }, fetchPromise);
  };

  export const [
    fetchEnrolledFluencies,
    receiveEnrolledFluencies,
    fetchEnrolledFluenciesError
  ] = createAsyncActions(
    'GET_ENROLLED_FLUENCIES',
    ({ id }) => ({ id }),
    ({ data }) => ({ enrolledFluencies: data.userFluences , showSurvey: data.show_feedback_form })
  );

  export const getEnrolledFluenciesFn = (id) => {
    const fetchPromise = ReadingProgram.getEnrolledFluencies(id);

    return runAsyncWorkflow({
      fetch: fetchEnrolledFluencies,
      receive: receiveEnrolledFluencies,
      error: fetchEnrolledFluenciesError
    }, fetchPromise);
  };

  export const openOnboardingForm = createAction('OPEN_ONBOARDING_FORM');
  export const closeOnboardingForm = createAction('CLOSE_ONBOARDING_FORM');

  export const selectUserType = createAction('SELECT_USER_TYPE');
  export const selectNumberOfStudents = createAction('SELECT_NUMBER_OF_STUDENT');

  export const [
    fetchNextThemeSuggestion,
    recieveNextThemeSuggestion,
    fetchNextThemeSuggestionError
  ] = createAsyncActions(
    'GET_NEXT_THEME_SUGGESTION',
    ({id}) => ({id}),
    ({data}) => ({nextThemeSuggestion: data.nextThemeSuggestion})
  );

  export const getNextThemeSuggestion = (id) => {
    const fetchPromise = ReadingProgram.getNextThemeSuggestion(id);

    return runAsyncWorkflow({
      fetch: fetchNextThemeSuggestion,
      receive: recieveNextThemeSuggestion,
      error: fetchNextThemeSuggestionError
    }, fetchPromise);
  };

  export const [
    fetchLandingPageImages,
    recieveLandingPageImages,
    fetchLandingPageImagesError
  ] = createAsyncActions(
    'GET_LANDING_PAGE_IMAGES',
    () => ({}),
    ({ data }) => ({ readingProgramImages: data })
  );

  export const getLandingPageImages = () => {
    const fetchPromise = ReadingProgram.getLandingPageImages();

    return runAsyncWorkflow({
      fetch: fetchLandingPageImages,
      receive: recieveLandingPageImages,
      error: fetchLandingPageImagesError
    }, fetchPromise);
  };

  export const [
    fetchLandingPageContent,
    recieveLandingPageContent,
    fetchLandingPageContentError
  ] = createAsyncActions(
    'GET_LANDING_PAGE_CONTENT',
    () => ({}),
    ({ data }) => ({ data })
  );

  export const getLandingPageContent = () => {
    const fetchPromise = ReadingProgram.fetchHomepageContent();

    return runAsyncWorkflow({
      fetch: fetchLandingPageContent,
      receive: recieveLandingPageContent,
      error: fetchLandingPageContentError
    }, fetchPromise);
  };

  export const [
    fetchThemePageContent,
    recieveThemePageContent,
    fetchThemePageContentError
  ] = createAsyncActions(
    'GET_THEME_PAGE_CONTENT',
    (fluencyLevel, themeNumber) => ({fluencyLevel, themeNumber}),
    ({ data }) => ({ data })
  );

  export const getThemePageContent = (fluencyLevel, themeNumber) => {
    const fetchPromise = ReadingProgram.getThemePageConstantData(fluencyLevel, themeNumber);

    return runAsyncWorkflow({
      fetch: fetchThemePageContent,
      receive: recieveThemePageContent,
      error: fetchThemePageContentError
    }, fetchPromise);
  };

  export const [
    postRpSurveyFormFeedback,
    receivePostRpSurveyFormFeedback,
    postRpSurveyFormFeedbackError
  ] = createAsyncActions(
    'RP_SURVEY_FORM_FEEDBACK',
    () => ({})
  );
  
  export const postRpSurveyFormFeedbackWorkflow = (postRpSurveyFormFeedbackPayload) => {
    const fetchPromise = ReadingProgram.submitRpSurveyFormFeedback(postRpSurveyFormFeedbackPayload);
  
    return runAsyncWorkflow(
      {
        fetch: postRpSurveyFormFeedback,
        receive: receivePostRpSurveyFormFeedback,
        error:   postRpSurveyFormFeedbackError
      },
      fetchPromise,
      postRpSurveyFormFeedbackPayload
    );
  };
  

  export const [
    fetchRpCertDownload,
    recieveRpCertDownload,
    fetchRpCertDownloadError
  ] = createAsyncActions(
    'GET_RP_CERTIFICATE',
    ({ id}) => ({ id }),
    ({  ok, url, msg}) => ({  ok, url, msg})
  );

  export const getRPCertificate =  (id) => {
    const fetchPromise = ReadingProgram.getRpCertificateData(id);

    return runAsyncWorkflow({
      fetch: fetchRpCertDownload,
      receive: recieveRpCertDownload,
      error:   fetchRpCertDownloadError
    }, fetchPromise)
  }


  export const goToFluencyTheme = createAction('GO_TO_FLUENCY_THEME');

  export const [
    fetchGoaSchoolDetails,
    receiveGoaSchoolDetails,
    fetchGoaSchoolDetailsError
  ] = createAsyncActions(
    'GET_GOA_SCHOOL_DETAILS',
    () => {},
    ({ok, data }) => ({ok, data: data.school_details })
  );

  export const getGoaSchoolDetails = (locale, udiseCode) => {
    const fetchPromise = ReadingProgram.getGoaSchoolDetails(locale, udiseCode);

    return runAsyncWorkflow({
      fetch: fetchGoaSchoolDetails,
      receive: receiveGoaSchoolDetails,
      error: fetchGoaSchoolDetailsError
    }, fetchPromise);
  };


// WEBPACK FOOTER //
// ./src/redux/allFluencesActions.js